<template>
  <div id="client-app">
    <router-view />
    <chat-float v-if="showFloat" :embed-mode="isEmbed" />
  </div>
</template>

<script>
import ChatFloat from '@/components/ChatFloat.vue'

export default {
  name: 'App',
  components: { ChatFloat },
  data() {
    return {
      // 首页当前标签：ai = AI 问答助手（页面内已完整展示对话，隐藏悬浮小窗）；kb = 检索文章（保留悬浮小窗）
      homeTab: 'ai'
    }
  },
  computed: {
    isEmbed() {
      return this.$route.name === 'Embed'
    },
    showFloat() {
      const name = this.$route.name
      if (name === 'Embed') return true
      if (name === 'Home') return this.homeTab !== 'ai'
      return false
    }
  },
  created() {
    this.$root.$on('home-tab', this.onHomeTab)
  },
  beforeDestroy() {
    this.$root.$off('home-tab', this.onHomeTab)
  },
  methods: {
    onHomeTab(tab) {
      this.homeTab = tab || 'ai'
    }
  }
}
</script>

<style>
#client-app {
  min-height: 100vh;
}
</style>
